/** Workspaces piloto quando nenhuma env de allowlist está definida. */
const DEFAULT_UAZAPI_ALLOWED_WORKSPACES = new Set<string>([
  "9c074afa-6c08-4ef7-ba5a-a4551a6eac0f", // atendimento.fabtech@gmail.com
]);

function parseWorkspaceAllowlist(envValue: string | undefined): Set<string> | null {
  if (!envValue?.trim()) return null;
  const ids = envValue
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  return ids.length > 0 ? new Set(ids) : null;
}

function getUazapiWorkspaceAllowlist(): Set<string> {
  return (
    parseWorkspaceAllowlist(import.meta.env.VITE_UAZAPI_ALLOWED_WORKSPACES) ??
    DEFAULT_UAZAPI_ALLOWED_WORKSPACES
  );
}

/**
 * Piloto do novo fluxo WhatsApp Business (whatsapp_uazapi).
 *
 * Habilitado quando:
 * - `VITE_UAZAPI_ENABLED=true` (build flag Lovable — todos os workspaces), ou
 * - `import.meta.env.DEV`, ou
 * - workspace na allowlist (`VITE_UAZAPI_ALLOWED_WORKSPACES` ou lista padrão no código).
 */
export function isUazapiEnabledForWorkspace(workspaceId: string | null | undefined): boolean {
  if (!workspaceId) return false;
  // Rollout global: fluxo whatsapp_uazapi já é o padrão para todos os workspaces.
  // Mantemos a allowlist/env apenas como referência histórica — sempre habilitado.
  void getUazapiWorkspaceAllowlist;
  return true;
}
